<template>
  <div>
    <t-form label-width="90px">
      <CptData :data="attribute.cptTableData" :cptDataForm="cptDataForm"/>
      <t-form-item label="排列方向">
        <t-radio-group v-model="attribute.direction" size="small">
          <t-radio-button value="x">竖向</t-radio-button>
          <t-radio-button value="y">横向</t-radio-button>
        </t-radio-group>
      </t-form-item>
      <t-form-item label="数据处理" v-show="attribute.enablePa">
        <t-radio-group v-model="attribute.enablePa" size="small">
          <t-radio-button value="1">百分比</t-radio-button>
          <t-radio-button value="0">数值</t-radio-button>
        </t-radio-group>
      </t-form-item>
      <t-form-item label="柱类型" v-show="attribute.series.barType">
        <t-select v-model="attribute.series.barType" size="small">
          <t-option label="普通柱状图" value="bar" />
          <t-option label="象形柱状图" value="pictorialBar" />
        </t-select>
      </t-form-item>

      <t-form-item label="柱体样式" v-show="attribute.series.barType === 'pictorialBar'">
        <e-shape-select v-model="attribute.series.symbol" />
      </t-form-item>
      <e-collapse title="标题" :expand="false">
        <t-form-item label="文本">
          <t-input v-model="attribute.title.text" size="small" :maxcharacter="52" />
        </t-form-item>
        <t-form-item label="大小">
          <t-input-number v-model="attribute.title.textStyle.fontSize" size="small" :min="2" :max="100"
            :decimal-places="0" />
        </t-form-item>
        <t-form-item label="颜色">
          <t-color-picker :colorModes="['monochrome']" format="HEX" v-model="attribute.title.textStyle.color"
            size="small" />
        </t-form-item>
        <t-form-item label="位置(X)">
          <e-chart-position v-model="attribute.title.left" :direction="'x'" />
        </t-form-item>
        <t-form-item label="位置(Y)">
          <e-chart-position v-model="attribute.title.top" :direction="'y'" />
        </t-form-item>
      </e-collapse>
      <e-collapse title="图例" :expand="false">
        <t-form-item label="显示">
          <t-switch v-model="attribute.legend.show" :label="['开', '关']" size="small" />
        </t-form-item>
        <t-form-item label="位置(X)">
          <e-chart-position v-model="attribute.legend.left" :direction="'x'" />
        </t-form-item>
        <t-form-item label="位置(Y)">
          <e-chart-position v-model="attribute.legend.top" :direction="'y'" />
        </t-form-item>
        <t-form-item label="布局方式">
          <t-radio-group v-model="attribute.legend.orient" size="small">
            <t-radio-button value="vertical">纵向</t-radio-button>
            <t-radio-button value="horizontal">横向</t-radio-button>
          </t-radio-group>
        </t-form-item>
        <t-form-item label="字体">
          <t-input-number size="small" v-model="attribute.legend.textStyle.fontSize" :min="2" :max="120"
            :decimal-places="0" />
        </t-form-item>
        <t-form-item label="文字颜色">
          <t-color-picker :colorModes="['monochrome']" format="HEX" size="small"
            v-model="attribute.legend.textStyle.color" />
        </t-form-item>
      </e-collapse>
      <e-collapse title="内边距" :expand="false">
        <t-form-item label="内边距(左)">
          <t-input-number size="small" v-model="attribute.grid.x" :min="0" :max="200" :decimal-places="0" />
        </t-form-item>
        <t-form-item label="内边距(上)">
          <t-input-number size="small" v-model="attribute.grid.y" :min="0" :max="200" :decimal-places="0" />
        </t-form-item>
        <t-form-item label="内边距(右)">
          <t-input-number size="small" v-model="attribute.grid.x2" :min="0" :max="200" :decimal-places="0" />
        </t-form-item>
        <t-form-item label="内边距(下)">
          <t-input-number size="small" v-model="attribute.grid.y2" :min="0" :max="200" :decimal-places="0" />
        </t-form-item>
      </e-collapse>
      <e-collapse title="x轴" :expand="false">
        <t-form-item label="显示">
          <t-switch v-model="attribute.xAxis.show" :label="['开', '关']" size="small" />
        </t-form-item>
        <t-form-item label="指示文字">
          <t-input v-model="attribute.xAxis.name" size="small" :maxcharacter="40" />
        </t-form-item>
        <t-form-item label="轴线显示">
          <t-switch v-model="attribute.xAxis.axisLine.show" :label="['开', '关']" size="small" />
        </t-form-item>
        <t-form-item label="轴线颜色">
          <t-color-picker :colorModes="['monochrome']" format="HEX" v-model="attribute.xAxis.axisLine.lineStyle.color"
            size="small" />
        </t-form-item>
        <t-form-item label="刻度线">
          <t-switch v-model="attribute.xAxis.axisTick.show" :label="['开', '关']" size="small" />
        </t-form-item>
        <t-form-item label="网格线">
          <t-switch v-model="attribute.xAxis.splitLine.show" :label="['开', '关']" size="small" />
        </t-form-item>
        <t-form-item label="字体颜色">
          <t-color-picker :colorModes="['monochrome']" format="HEX" v-model="attribute.xAxis.axisLabel.color"
            size="small" />
        </t-form-item>
        <t-form-item label="字号">
          <t-input-number v-model="attribute.xAxis.axisLabel.fontSize" :min="1" :max="100" size="small"
            :decimal-places="0" />
        </t-form-item>
        <t-form-item label="字体倾斜">
          <t-input-number v-model="attribute.xAxis.axisLabel.rotate" :min="-180" :max="180" size="small"
            :decimal-places="0" />
        </t-form-item>
        <t-form-item label="显示间隔">
          <t-select v-model="attribute.xAxis.axisLabel.interval" size="small">
            <t-option label="自动" value="auto" />
            <t-option label="全部显示" :value="0" />
            <t-option label="隔1列" :value="1" />
            <t-option label="隔2列" :value="2" />
            <t-option label="隔3列" :value="3" />
            <t-option label="隔4列" :value="4" />
            <t-option label="隔5列" :value="5" />
          </t-select>
        </t-form-item>
      </e-collapse>
      <e-collapse title="y轴" :expand="false">
        <t-form-item label="显示">
          <t-switch v-model="attribute.yAxis.show" :label="['开', '关']" size="small" />
        </t-form-item>
        <div v-show="attribute.yAxis.show">
          <t-form-item label="指示文字">
            <t-input v-model="attribute.yAxis.name" size="small" :maxcharacter="40" />
          </t-form-item>
          <t-form-item label="轴线显示">
            <t-switch v-model="attribute.yAxis.axisLine.show" :label="['开', '关']" size="small" />
          </t-form-item>
          <t-form-item label="轴颜色">
            <t-color-picker :colorModes="['monochrome']" format="HEX" v-model="attribute.yAxis.axisLine.lineStyle.color"
              size="small" />
          </t-form-item>
          <t-form-item label="网格线">
            <t-switch v-model="attribute.yAxis.splitLine.show" :label="['开', '关']" size="small" />
          </t-form-item>
          <t-form-item label="网格线颜色" v-if="attribute.yAxis.splitLine.lineStyle">
            <t-color-picker :colorModes="['monochrome']" format="HEX" size="small"
              v-model="attribute.yAxis.splitLine.lineStyle.color[0]" />
            <t-color-picker :colorModes="['monochrome']" format="HEX" size="small"
              v-model="attribute.yAxis.splitLine.lineStyle.color[1]" />
          </t-form-item>
          <t-form-item label="网格线样式">
          <t-radio-group v-model="attribute.yAxis.splitLine.lineStyle.type" size="small">
            <t-radio-button value="solid">实线</t-radio-button>
            <t-radio-button value="dashed">虚线</t-radio-button>
          </t-radio-group>
        </t-form-item>
          <t-form-item label="刻度线">
            <t-switch v-model="attribute.yAxis.axisTick.show" :label="['开', '关']" size="small" />
          </t-form-item>
          <t-form-item label="字体颜色">
            <t-color-picker :colorModes="['monochrome']" format="HEX" v-model="attribute.yAxis.axisLabel.color"
              size="small" />
          </t-form-item>
          <t-form-item label="字号">
            <t-input-number v-model="attribute.yAxis.axisLabel.fontSize" :min="1" :max="100" size="small"
              :decimal-places="0" />
          </t-form-item>
          <t-form-item label="文本格式">
            <t-input v-model="attribute.yAxis.axisLabel.formatter" size="small" :maxcharacter="52" />
          </t-form-item>
        </div>
      </e-collapse>
      <e-collapse title="数值" :expand="false">
        <t-form-item label="数值显示">
          <t-switch v-model="attribute.series.label.show" :label="['开', '关']" size="small" />
        </t-form-item>
        <t-form-item label="堆叠合计" v-if="currentCpt.cptKey == 'cpt-chart-column-stack'">
          <t-switch v-model="attribute.series.label.stackShow" :label="['开', '关']" size="small" />
        </t-form-item>
        <t-form-item label="合计小数点">
          <t-input-number v-model="attribute.series.label.fixed" :min="0" :max="10" size="small"
            :decimal-places="0" />
        </t-form-item>
        <t-form-item label="数值字体">
          <t-input-number v-model="attribute.series.label.fontSize" :min="2" :max="100" size="small"
            :decimal-places="0" />
        </t-form-item>
        <t-form-item label="数值颜色">
          <t-color-picker :colorModes="['monochrome']" format="HEX" v-model="attribute.series.label.color" size="small" />
        </t-form-item>
        <t-form-item label="数值位置" v-show="attribute.series.label.position">
          <t-select v-model="attribute.series.label.position" size="small">
            <t-option label="顶部" value="top" />
            <t-option label="左" value="left" />
            <t-option label="右" value="right" />
            <t-option label="底部" value="bottom" />
            <t-option label="中心" value="inside" />
          </t-select>
        </t-form-item>
        <t-form-item label="数值单位">
          <t-input v-model="attribute.series.label.unit" size="small" :maxcharacter="52" />
        </t-form-item>
      </e-collapse>
      <e-collapse title="柱体" :expand="true">
        <div v-show="attribute.series.barType === 'bar'">
          <t-form-item label="柱体背景">
            <t-switch v-model="attribute.series.showBackground" :label="['开', '关']" size="small" />
          </t-form-item>
          <t-form-item label="圆角">
            <t-input-number v-model="attribute.series.borderRadius" :min="0" :max="50" size="small" :decimal-places="0" />
          </t-form-item>
        </div>
        <t-form-item label="柱体宽度">
          <t-input-number v-model="attribute.series.barWidth" :min="1" :max="100" size="small" :decimal-places="0" />
        </t-form-item>
        <t-form-item label="柱体间距">
          <t-input-number v-model="attribute.series.barGap" :step="0.1" :min="0.1" :max="100" size="small" :decimal-places="1" />
        </t-form-item>
        <t-form-item label="柱体配色">
          <e-color-group v-model="attribute.color" :max="20" :gradient="true" />
        </t-form-item>
        <t-form-item label="平滑曲线">
        <t-switch v-model="attribute.series.smooth" :label="['开', '关']" size="small" />
      </t-form-item>
      </e-collapse>
      <t-form-item label="X轴拖动" v-if="attribute.dataZoom">
         <t-switch v-model="attribute.dataZoom.show"/> 
      </t-form-item>
       <t-form-item label="X轴拖动高度" v-if="attribute.dataZoom && attribute.dataZoom.show">
         <t-input-number v-model="attribute.dataZoom.height" :min="0" :max="50" size="small" :decimal-places="0"/>
       </t-form-item>
    </t-form>
  </div>
</template>

<script>
import EColorGroup from "@/components/designer/e-color-group";
import EChartPosition from "@/components/designer/e-chart-position";
import EShapeSelect from "@/components/designer/e-shape-select.vue";
import CptData from '@/components/element/options/comp/cpt-data'
export default {
  name: "cpt-chart-column-option",
  components: { EShapeSelect, EChartPosition, EColorGroup,CptData },
  props: {
    attribute: Object,
    cptDataForm:Object,
    currentCpt: Object,
  },
}
</script>

<style scoped></style>
